<template>
  <b-row class="my-3" align-v="center" >
    <b-col :sm="labelWidth" class="text-left">
      <label class="mb-0 align-middle">{{this.label}}</label>
    </b-col>
    <b-col :sm="inputWidth">
      <vue-timepicker v-if="!disabled"  v-model="fieldInput" :format="this.format" :second-interval="this.secondInterval" :minute-interval="this.minuteInterval"></vue-timepicker>
      <b-form-input class='TimePickerDisabled' v-else  :value="(disabledPlaceholder)? this.disabledPlaceholder : this.timeFormatter(fieldInput)" :disabled="disabled"></b-form-input>
    </b-col>
  </b-row>
</template>
<script type="text/javascript">
/* eslint-disable */
import Vue from 'vue'
import moment from 'moment'
import VueTimepicker from 'vue2-timepicker'

export default {
  name: 'FITTimepicker',
  components: {
    VueTimepicker,
  },
  props: {
    label: String,
    initValue: Object,
    width: {
      type: Number,
      default: 10
    },
    lang: String,
    format: { // Format list refer to : https://phoenixwong.github.io/vue2-timepicker/
      type: String,
      default: 'HH:mm:ss'
    },
    minuteInterval: Number,
    secondInterval: Number,
    disabled:Boolean,
    disabledPlaceholder:{
      type:String,
    },
    value:String,
  },
  data() {
    return {
      fieldInput: this.value, // Input String Value
      inputWidth: this.width
    }
  },

  mounted() {
    this.labelCheck(this.label);
  },
  watch: {
    fieldInput:{
      handler(val){
        if(val==null){
          this.$emit('input', null);
        }else{
          this.$emit('input', this.timeFormatter(val));
        }
      
      },
    },
    value:{
      handler(val){

        if(val == null){
         this.fieldInput = null;
         return; 
        }

        let timeObj = {
          HH:'00',
          mm:'00',
          ss:'00',
        };
        if(val){
        let time = val.split(":");
        timeObj.HH = time[0];
        timeObj.mm = time[1];
        timeObj.ss = time[2]; 
        }
        this.fieldInput = timeObj;

      },
      immediate:true
    }
  },
  computed: {
    labelWidth() {
      return 12 - this.inputWidth;
    }
  },
  methods: {
    labelCheck(label) {
      if (!label) {
        this.inputWidth = 12;
      }
    },
    timeFormatter(time) {
      if (!time.HH) {
        time.HH = "00";
      }
      if (!time.mm) {
        time.mm = "00";
      }
      if (!time.ss) {
        time.ss = "00";
      }
      return time.HH + ':' + time.mm + ":" + time.ss;


    }
  }
}

</script>
<style>
.time-picker,
.time-picker input {
  width: 100% !important;
  height: 35px !important;
}

.time-picker .dropdown ul li {
  color: #555 !important;
}

.time-picker input.display-time {
  border: 1px solid #CDCDCD !important;
  border-radius: 4px;
  color: #555 !important;
  font-size: 0.875rem !important;
}

.time-picker .dropdown ul li.active,
.time-picker .dropdown ul li.active:hover {
  background: #007bff !important;
  color: #fff !important;
}
.TimePickerDisabled{
  padding-left:  10px; 
  font-size: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/Form/FITTimepicker.vue